import { createSlotRecipeContext, HTMLChakraProps } from '@chakra-ui/react';
import { LatLongInputList } from '@components/ui/coordinatesInput/list/LatLongInputList';
import { PositionPickerList } from '@components/ui/coordinatesInput/list/PositionPickerList';
import { UnitSelectorList } from '@components/ui/coordinatesInput/list/UnitSelectorList';

import { CoordinatesUnit } from '@/types/commons/commons.types';

const { withProvider, withContext } = createSlotRecipeContext({ key: 'gpsCoordinatesList' });

export type GPSCoordinatesListRootProps = HTMLChakraProps<'div'>;
export const GPSCoordinatesListRoot = withProvider<HTMLDivElement, GPSCoordinatesListRootProps>('div', 'root');

export type GPSCoordinatesListUnitSelectorProps = HTMLChakraProps<'div'> & {
  unit: CoordinatesUnit;
  onUnitChange: (value: CoordinatesUnit) => void;
};
export const GPSCoordinatesListUnitSelector = withContext<HTMLDivElement, GPSCoordinatesListUnitSelectorProps>(
  UnitSelectorList,
  'unitSelectorList',
);

export type GPSCoordinatesListPositionPickerProps = HTMLChakraProps<'button'>;
export const GPSCoordinatesListPositionPicker = withContext<HTMLDivElement, GPSCoordinatesListPositionPickerProps>(
  PositionPickerList,
  'positionPickerList',
);

export type GPSCoordinatesListInputProps = {
  type: 'latitude' | 'longitude';
  name: string;
  unit: CoordinatesUnit;
  onPolygonChange: (field: string, value: string) => void;
  readOnly?: boolean;
} & Omit<HTMLChakraProps<'div'>, 'value' | 'onChange'>;
export const GPSCoordinatesListInput = withContext<HTMLInputElement, GPSCoordinatesListInputProps>(
  LatLongInputList,
  'inputList',
);
